<template>
  <div class="modal">
    <div class="modal-content" v-click-outside="closeModalOutside">
      <div class="title" v-if="this.message == 'Notice Resent.'">Success</div>
      <div class="warningtitle" v-else>Warning</div>
      <div class="txt">
        {{this.message}}
      </div>
      <button class="btn" @click="nextStep">Ok</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminAlertModal",
  props: ["message"],
  methods: {
    closeModalOutside() {
      this.$emit("closeAlertModal", false);
    },
    nextStep() {
      this.$emit("closeAlertModal", false);
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../styles/colors";
.modal {
  width: 100%;
  height: 100%;
  background-color: rgba(219, 230, 241, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  position: relative;
  padding: 36px 35px 40px 35px;
  background-color: $white;
  max-width: 385px;
  width: 100%;
  max-height: 385px;
  border-radius: 10px;
}
.title {
  color: $blue;
  font-family: TTNormsBold, sans-serif;
  font-size: 27px;
  text-align: center;
  margin: 0 0 36px 0;
}

.warningtitle {
  color: $yellow;
  font-family: TTNormsBold, sans-serif;
  font-size: 27px;
  text-align: center;
  margin: 0 0 36px 0;
}
.btn {
  background-color: $green;
  min-width: 50%;
  margin: 36px auto 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $white;
  cursor: pointer;
  outline: none;
  border: 1px solid transparent;
  height: 45px;
  border-radius: 25px;
  font-size: 18px;
  transition: all 0.5s linear;
  font-family: TTNormsBold, sans-serif;
}
.back-btn {
  color: $green;
  border: none;
  cursor: pointer;
  outline: none;
  display: block;
  margin: 36px auto 0 auto;
  background-color: transparent;
  font-size: 16px;
  font-family: TTNormsMedium, sans-serif;
}

.text {
  text-align: center;
  font-size: 16px;
  font-family: TTNormsRegular, sans-serif;
  line-height: 20px;
  margin-bottom: 36px;
}

@media (max-width: 1024px) {
  .modal-content {
    margin: 0 auto;
  }
}

@media (max-width: 568px) {
  .modal-content {
    padding: 20px;
    max-width: 100%;
  }
}
.txt {
  text-align: center;
}
</style>
